import { PluginsUIPlugin } from '@stereograph/teiaviewer-plugins-ui-react';
import {
  DefaultToolbarItems,
  Dock, DockProps, ToolbarItemGroup,
} from '@stereograph/teiaviewer-viewport-react';

export const AppDock = (props: DockProps) => {
  return (
    <Dock {...props}>
      <ToolbarItemGroup>
        <DefaultToolbarItems.NotificationCenter />
        <DefaultToolbarItems.ShowSettingsWidget />
      </ToolbarItemGroup>
      <ToolbarItemGroup>
        <DefaultToolbarItems.SelectionInfoMenu>
          <DefaultToolbarItems.HideObjects />
          <DefaultToolbarItems.IsolateObjects />
          <DefaultToolbarItems.FocusObjects />
        </DefaultToolbarItems.SelectionInfoMenu>
      </ToolbarItemGroup>
      <ToolbarItemGroup>
        <DefaultToolbarItems.ResetScene />
        <DefaultToolbarItems.RenderMode />
        <DefaultToolbarItems.CameraMode />
        <PluginsUIPlugin.ToolbarItems.TeiaSearchToolbarItem />
        <DefaultToolbarItems.ShowInfoBox />
        <DefaultToolbarItems.ShowTreeView />
        <DefaultToolbarItems.ScreenShot />
        <DefaultToolbarItems.UndoCommand />
        <DefaultToolbarItems.RedoCommand />
        <DefaultToolbarItems.ShowDevTools />
        <DefaultToolbarItems.ShowCommandHistory />
        <DefaultToolbarItems.ShowToolbar />
      </ToolbarItemGroup>
    </Dock>
  );
};
